/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleHasMaxDaysRestrictionApiRequest } from '../../models/hotel-edit-single-has-max-days-restriction-api-request';

export interface ApiHotelManageEditSingleMaxdaysRestrictionPost$Params {
      body: HotelEditSingleHasMaxDaysRestrictionApiRequest
}

export function apiHotelManageEditSingleMaxdaysRestrictionPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleMaxdaysRestrictionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleMaxdaysRestrictionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleMaxdaysRestrictionPost.PATH = '/api/hotel/manage/edit/single/maxdays-restriction';
